/** @format */
import React from 'react'
import './Contact.css'
import { useContext } from 'react'
import { themeContext } from '../../Context'

const Contact = () => {
	// context
	const theme = useContext(themeContext)
	const darkMode = theme.state.darkMode

	return (
		<div className="contact-form" id="contact">
			{/* left side copy and paste from work section */}
			<div className="w-left">
				<div className="awesome">
					{/* darkMode */}
					<span style={{ color: darkMode ? 'white' : '' }}>Get in Touch</span>
					<span>Contact me</span>
					<div
						className="blur s-blur1"
						style={{ background: '#ABF1FF94' }}></div>
				</div>
			</div>
			{/* right side form */}
			<div className="c-right">
				<form>
					<input
						type="text"
						name="user_name"
						className="user"
						placeholder="Name"
					/>
					<input
						type="email"
						name="user_email"
						className="user"
						placeholder="Email"
					/>
					<textarea name="message" className="user" placeholder="Message" />
					<input type="submit" value="Send" className="button" />
					<div
						className="blur c-blur1"
						style={{ background: 'var(--purple)' }}></div>
				</form>
			</div>
		</div>
	)
}

export default Contact
